/* eslint-disable lines-around-comment */
import React from 'react';
import Button from '../../../base/ui/components/web/Button';
// @ts-ignore
import AbstractPollsPane from '../AbstractPollsPane';
import PollCreate from './PollCreate';
// @ts-ignore
import PollsList from './PollsList';
const PollsPane = (props) => {
    const { createMode, onCreate, setCreateMode, t } = props;
    return createMode
        ? React.createElement(PollCreate, { setCreateMode: setCreateMode })
        : React.createElement("div", { className: 'polls-pane-content' },
            React.createElement("div", { className: 'poll-container' },
                React.createElement(PollsList, null)),
            React.createElement("div", { className: 'poll-footer poll-create-footer' },
                React.createElement(Button, { accessibilityLabel: t('polls.create.create'), autoFocus: true, fullWidth: true, labelKey: 'polls.create.create', onClick: onCreate })));
};
/*
 * We apply AbstractPollsPane to fill in the AbstractProps common
 * to both the web and native implementations.
 */
// eslint-disable-next-line new-cap
export default AbstractPollsPane(PollsPane);
